<template>
  <div class="video-page-wrapper">
    <div style="display: flex; flex-direction: row">
      <img style="max-height: 50vh; height: 100%; margin-right: 10px; max-width: 47%" src="@/assets/pages/secure-video.jpg" alt="img" />
      <img style="max-height: 50vh; height: 100%; max-width: 47%" src="@/assets/pages/secure-video-2.jpg" alt="img" />
    </div>

    <PageTabs>
      <template v-slot:first>
        <div>
          <div class="video-page-texts video-page-texts-no-offset">
            <div>
              <h3>{{ $t("pages.security-cameras.subtitle1") }}</h3>
              <p>{{ $t("pages.security-cameras.text1") }}</p>
            </div>
          </div>
          <ProductsRow :products="products"></ProductsRow>
        </div>
      </template>
      <template v-slot:second>
        <VoiceCommands :commands="commands"></VoiceCommands>
      </template>
    </PageTabs>
  </div>
</template>

<script>
import PageTabs from "../components/PageTabs";
import VoiceCommands from "../components/VoiceCommands";
import ProductsRow from "../components/ProductsRow";
export default {
  name: "SecurityCameras",
  components: { ProductsRow, VoiceCommands, PageTabs },
  data() {
    return {
      commands: this.$t("pages.security-cameras.commands"),
      products: [
        { img: "cameras/camera-circle.png", text: "Logitech Circle", price: "160" },
        { img: "cameras/camera-ecobee.png", text: "Ecobee", price: "166" },
        { img: "cameras/camera-netatmo.png", text: "Netatmo", price: "160" },
        { img: "cameras/camera-arlo.png", text: "Arlo", price: "116" }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.img-music {
  width: 100%;
  max-width: 200px;
}
</style>
